module.exports = __webpack_public_path__ + "static/media/contact1.44313377.png";